import './polyfills'; // Must be first import!
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/easytiger-design-system.css'; // Design system foundation
import './styles/easytiger-animations.css'; // Animation library
import './styles/demo-clarity.css'; // Demo clarity overrides for screen-share legibility
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global error handler
window.addEventListener('error', (event) => {
  console.error('💥 [GLOBAL ERROR]', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('💥 [UNHANDLED REJECTION]', event.reason);
});

console.log('🌐 [INDEX] Starting EasyTiger app...');
console.log('🌐 [INDEX] Current URL:', window.location.href);

// Render app immediately for fast startup
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Report web vitals
reportWebVitals();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
